export default __webpack_public_path__ + "static/media/gameOver1.c4295829.mp3";